import { computed, type WritableComputedRef } from 'vue'

import { useNuxtApp } from 'nuxt/app'

const BREAKPOINTS = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
} as const

type ViewportAdapter = {
  breakpoint: WritableComputedRef<string>
  isGreaterThan: (breakpoint: string) => boolean
  isLessThan: (breakpoint: string) => boolean
  match: (breakpoint: string) => boolean
}

/**
 * Предоставляет реактивные признаки текущего viewport breakpoint.
 *
 * @returns breakpoint и вычисляемые признаки размеров экрана
 */
export const useResponsive = () => {
  const { $viewport } = useNuxtApp()
  const viewport = $viewport as ViewportAdapter

  const isMobile = computed(() => viewport.match(BREAKPOINTS.mobile))
  const isMobileOrTablet = computed(() =>
    viewport.isLessThan(BREAKPOINTS.desktop),
  )
  const isTablet = computed(() => viewport.match(BREAKPOINTS.tablet))
  const isDesktop = computed(() => viewport.match(BREAKPOINTS.desktop))
  const isDesktopOrTablet = computed(() =>
    viewport.isGreaterThan(BREAKPOINTS.mobile),
  )

  return {
    breakpoint: viewport.breakpoint,
    isMobile,
    isMobileOrTablet,
    isTablet,
    isDesktop,
    isDesktopOrTablet,
  }
}
